import { ChangeEvent } from 'react';

import { EventResponse } from 'generated/index';

import { Box, Checkbox } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import EventRow from './EventRow';
import { formatHoursMinutes } from 'utils/date';

type ListViewTableProps = {
  title: string;
  columns: GridColDef[];
  events: EventResponse[];
  selectableEvents: EventResponse[];
  onCheckboxChange: (
    e: ChangeEvent<HTMLInputElement>,
    value: string[] | string
  ) => void;
  checked: string[];
};

export default function ListViewTable({
  title,
  columns,
  events,
  selectableEvents,
  onCheckboxChange,
  checked
}: ListViewTableProps) {
  const isSelectable = selectableEvents.length > 0;
  const totalDuration = events.reduce(
    (acc, row) => acc + row.durationInSeconds,
    0
  );

  return (
    <Box mb={3}>
      <Box display="flex" alignItems="center" mb={1}>
        {isSelectable && (
          <Checkbox
            indeterminate={
              selectableEvents.some(({ id }) => checked.includes(id)) &&
              !selectableEvents.every(({ id }) => checked.includes(id))
            }
            checked={selectableEvents.every(({ id }) => checked.includes(id))}
            onChange={(e) =>
              onCheckboxChange(
                e,
                selectableEvents.map(({ id }) => id)
              )
            }
          />
        )}
        {!isSelectable && <Box width={40} />}
        <Box
          sx={{
            fontSize: '14px',
            fontFamily: 'signikasemibold'
          }}
        >
          {title}
        </Box>
      </Box>
      {events.map((event, i) => {
        return (
          <EventRow
            key={`${i}-${event.id}`}
            columns={columns}
            event={event}
            onCheckboxChange={onCheckboxChange}
            checked={checked}
          />
        );
      })}
      <Box
        sx={{
          paddingLeft: '41px'
        }}
      >
        {formatHoursMinutes(totalDuration)}
      </Box>
    </Box>
  );
}
